var _style, _g, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasurement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 133.7 99.4",
    style: {
      enableBackground: "new 0 0 133.7 99.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#F2962E;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "UrFRTJ.tif",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 180,
    height: 106,
    id: "Layer_1_1_",
    xlinkHref: "909DFDD3F5C04D58.png",
    transform: "matrix(0.5 0 0 0.5 0.9284 47.059)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.2,39.6h39.5l-0.2,2.8H7L7.2,39.6z M7.7,34.1h43.7l-0.2,2.8H7.5L7.7,34.1z M8.2,28.5h39.5l-0.2,2.8H8 L8.2,28.5z M8.7,23h43.7l-0.2,2.8H8.5L8.7,23z M0.6,14.3l-3.3,36.8h16.3l13,17.4l16-17.4h16.3l3.3-36.8H0.6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.9,0L0,50.8h128.9L133.7,0H4.9z M30.5,39.5H16.8l2.4-28.1h13.8L30.5,39.5z M58.2,39.5H44.4l1.6-19h13.8 L58.2,39.5z M87.1,39.5H73.3l2.4-28.1h13.8L87.1,39.5z M115.7,39.5h-13.8l1.6-19h13.8L115.7,39.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "111.1,78.9 92.8,58.7 91.3,71 35.1,71 36.5,58.7 14,78.9 32.2,99.4 33.6,85.7 89.9,85.7 88.5,99.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurement);
export default __webpack_public_path__ + "static/media/measurement.baaef4f73201592823a7aea563119d0e.svg";
export { ForwardRef as ReactComponent };